const BaseModule = require('../../../../90_utils/base/BaseModule');
const VerticalGraph = require('../../../../80_bits/vertical-graph/script');

class SplitReadMoreGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$readMore = this.$el.find('.read-more-goop .goop-button');
		this.$expandedContent;
		this.expandedContentId = 'expanded-content' + (++window.SETTINGS.vars.svgIndex);

		this.$graph = this.$el.find('.vertical-graph');
		this.graph = new VerticalGraph(this.$graph);
	}

	// basemodule methods

	_domReady(){

		let $expandedContent = this.$el.find('.expanded-content');
		$expandedContent.css('height', 0);

		// enable modals from read more (weird)

		let modalId = this.$el.attr('data-modal-id') ? '#modal--' + this.$el.attr('data-modal-id') : '';

		if(modalId){
			this.$readMore.attr('data-modaal-href', modalId);
			this.$readMore.modaal();
		}

		this._resize();
	}

	_addListeners(){
		this.$readMore.on('click', $.proxy(this._onReadMoreClick, this));
	}

	_removeListeners(){
		this.$readMore.off('click', $.proxy(this._onReadMoreClick, this));
	}

	// listener methods

	_onReadMoreClick(e){
		this._toggleExpanded();
	}

	// toggle expanded content

	_toggleExpanded(){

		let $innerWrapper = this.$el.find('.text-block');
		let $textContent = this.$el.find('.text-content');
		let $description = this.$el.find('.description');
		let $expandedContent = this.$el.find('.expanded-content');

		this.$el.toggleClass('is-expanded');

		if(this.$el.hasClass('is-expanded')){

			TweenMax.set($expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){
				if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){
					let wrapperHeightTo = $textContent.outerHeight() + 160;
					TweenMax.to($innerWrapper, 0.3, {y: 0, opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
				}
			}
			else {
				if($textContent.outerHeight() + 120 >= $innerWrapper.outerHeight()){
					let wrapperHeightTo = $textContent.outerHeight() + 120;
					TweenMax.to($innerWrapper, 0.3, {y: 0, opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
				}
			}

			// animate

			TweenMax.fromTo($expandedContent, 0.3, {opacity:0, height: 0},
				{opacity:1, height: $expandedContent.outerHeight(), ease:Cubic.easeOut});
		}
		else {

			// correct wrapper

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height, y'});

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){

				let wrapperHeightTo = $innerWrapper.outerHeight();
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.to($innerWrapper, 0.3, {y:0, height: wrapperHeightTo, ease:Cubic.easeOut});
			}
			else {

				let wrapperHeightTo = $textContent.outerHeight() - $expandedContent.outerHeight(true) + 160;
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.to($innerWrapper, 0.3, {y:0, height: wrapperHeightTo, ease:Cubic.easeOut});
			}

			// shrink content

			TweenMax.to($expandedContent, 0.3, {opacity:0, height: 0, ease:Cubic.easeOut});
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let $textBlock = this.$el.find('>.text-block');
		let $graphBlock = this.$el.find('>.graph-block');
		let $graph = $graphBlock.find('.vertical-graph');

		let textBlockHeight = $textBlock.outerHeight();
		let graphBlockHeight = $graphBlock.outerHeight();
		let graphHeight = Math.min(textBlockHeight, window.SETTINGS.coords.winHeight, graphBlockHeight - 160);

		if(window.SETTINGS.breakpoint.minWidth('screen-phablet') && window.SETTINGS.breakpoint.maxWidth('screen-large')){

			$graph.css({
				top: '',
				width: '',
				height: ''
			});

		} else if(window.SETTINGS.breakpoint.minWidth('screen-large')){

			let textBounds = window.utils.PositioningUtils.getScrollOffset($textBlock);

			$graph.css({
				top: `calc(50% - ${graphHeight/2}px)`,
				width: Math.min(textBounds.left, $graphBlock.outerWidth()),
				height: graphHeight
			});
		}

		// set proper text box height

		let $innerWrapper = this.$el.find('.text-block');
		let $textContent = this.$el.find('.text-content');
		let $description = this.$el.find('.description');
		let $expandedContent = this.$el.find('.expanded-content');

		if(this.$el.hasClass('is-expanded')){

			TweenMax.killTweensOf([$innerWrapper, $expandedContent]);
			TweenMax.set($expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){
				if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){
					let wrapperHeightTo = $textContent.outerHeight() + 160;
					TweenMax.set($innerWrapper, {y: 0, opacity: 1, height: wrapperHeightTo});
				}
			}
			else {
				if($textContent.outerHeight() >= $innerWrapper.outerHeight()){
					let wrapperHeightTo = $textContent.outerHeight();
					TweenMax.set($innerWrapper, 0.3, {y: Math.round((wrapperHeightFrom - wrapperHeightTo)/2), opacity: 1, height: wrapperHeightTo});
				}
			}

			TweenMax.set($expandedContent, {opacity: 1, height: $expandedContent.outerHeight()});
		}
		else {

			// reset wrapper

			TweenMax.killTweensOf([$innerWrapper, $expandedContent]);

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height, y'});

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){

				let wrapperHeightTo = $innerWrapper.outerHeight();
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.set($innerWrapper, {y:0, height: wrapperHeightTo});
			}
			else {

				let wrapperHeightTo = $textContent.outerHeight() - $expandedContent.outerHeight(true) + 160;
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.set($innerWrapper, {y:0, height: wrapperHeightTo});
			}

			// shrink content

			TweenMax.set($expandedContent, {opacity: 0, height: 0});
		}
	}
}

module.exports = SplitReadMoreGraph;
